<template>
	<div class="a-h-100">
        <div class="a-w-100 a-h-100 a-bg-white a-plr-25 a-pb-40">
            <EarningsTrend class="stationStat a-w-100" :id="id" :params="params" :infoType="infoType"></EarningsTrend>
        </div>
	</div>
</template>
<script>
	import util from '../../../src/utils/util'
    import EarningsTrend from '../businessAnalysis/info-child/earningsTrend.vue';
	export default {
		components: {
			EarningsTrend
		},
		props: {
			incomeId: {
				required: true,
			}
		},
		data() {
			return {
				util:util,
				infoType: 'income',
                params: '',
                id: ''
			}
		},

		mounted() {},

		watch: {
			incomeId: {
				handler(val) {
					if (val) {
                        this.id = val
						this.params = {
                            incomeId: val
                        }
					}
				},
				immediate: true
			}
		},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>
    .stationStat{
        margin-top: 0 !important;
    }
    .a-h-100{
        height: 100%;
    }
</style>
